import { Redo, Logo } from '../../assets/icons'
import { useContext, useState } from 'react'
import { DocumentsContext, LoaderContext, SingleDocumentContext } from '../../context'
import moment from 'moment'
import { Send, MoreVert, Download, Close, More } from '@mui/icons-material'
import { ClickAwayListener } from '@mui/material'
import { useSingleDocumentActions } from '../../hooks'


const HeaderPublic = ({ full, fullHeader, pageTitle, hideTitleOnDesktop, titleIcon = null }) => {

  const { document, newComments, clearNewComments, promptSubmitComments, documentId } = useContext(SingleDocumentContext)
  const { downloadSharedDocument } = useSingleDocumentActions()
  const { lastReloadTime } = useContext(DocumentsContext)
  const { setLoading } = useContext(LoaderContext)
  const [showMoreActions, setShowMoreActions] = useState(false)


  const handleReload = () => {
  }

  const handleSendComments = () => {
    promptSubmitComments()
  }

  const handleCancelComments = () => {
    clearNewComments()
  }

  // On more actions click away
  const handleMoreActionsClickAway = () => {
    setShowMoreActions(false)
  }

  // On toggle more actions
  const handleToggleMoreActions = () => {
    setShowMoreActions(!showMoreActions)
  }

  const handleDownloadSharedDocument = async () => {
    setLoading(true)
    await downloadSharedDocument({ ...document, id: documentId })
    setLoading(false)
  }

  const MoreActionsButton = ({trigger, className = ''}) => {
    return (
      <ClickAwayListener onClickAway={handleMoreActionsClickAway}>
        <div className={`update ${className}`}>
          {trigger}
          {/* <button
            className="button action-btn small-icon"
            onClick={handleToggleMoreActions}
          >
            <span>
              <MoreVert />
              Outils
            </span>
          </button> */}
          {showMoreActions && (
            <div className="more-dropdown">
              <ul>
                <li className="">
                  <button onClick={handleDownloadSharedDocument}>
                    <span className="icon"><Download /></span>
                    <span className="text">
                      Télécharger
                    </span>
                  </button>
                </li>
              </ul>
            </div>
          )}
        </div>
      </ClickAwayListener>
    )
  }

  return (
    <header className={`public-header ${full ? 'public-header--full' : ''} ${fullHeader && 'public-header--full-width'}`}>
      <div className="logo">
        <Logo />
      </div>
      <div className="logo__mobile">
        <img src="/images/immodocs-logo-white-short.png" alt="Logo" />
      </div>
      <div className="public-header__right">
        <div className='update'>
          <div className='cursor-pointer' onClick={handleReload}>
            <Redo />
          </div>
          <span className='text'>Mise à jour </span>
          <span className='date'>{moment(lastReloadTime).format('DD/MM/YYYY')}</span>
        </div>
        <MoreActionsButton
          trigger={
            <button
              className="button action-btn small-icon"
              onClick={handleToggleMoreActions}
            >
              <span>
                <MoreVert />
                Outils
              </span>
            </button>
          }
        />

      </div>
      <div className="public-layout__body_mobile">

        <p className={`highlighted ${hideTitleOnDesktop && 'highlighted--hide'}`}>
          {!hideTitleOnDesktop && titleIcon && <div className='public-header__left__icon'>{titleIcon}</div>}
          <span>{pageTitle}</span>
        </p>
        <MoreActionsButton
          className="icon"
          trigger={
            <button
              className="btn btn--action btn--circle btn-circle--medium"
              onClick={handleToggleMoreActions}
            >
              <span>
                <MoreVert fontSize='medium' />
              </span>
            </button>
          }
        />
      </div>
    </header>
  )
}

export default HeaderPublic
